<template>
<div>
  <el-tabs class="tab-button" v-model="activeTab">
    <el-tab-pane label="인터페이스 상태" name="lineStatus">
      <w-line-status-table :formData="lineStatusData" :operation-flag="operationFlag" @time-type-change="setTimeType('lineStatus', $event)" @reload="selectedTabTableLoad" />
    </el-tab-pane>
    <!-- <el-tab-pane label="Syslog" name="syslog">
      <w-syslog-table :tableData="syslogTableData"/>
    </el-tab-pane> -->
    <el-tab-pane v-if="!operationFlag" label="연결장비" name="connectionDevice">
      <w-connection-device-table :tableData="connectionDeviceTableData" @time-type-change="setTimeType('connectionDevice', $event)" @reload="selectedTabTableLoad" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { analysisTimeType, defaultAnalysisTimeType } from '@/constants/performance';
import WLineStatusTable from '@/views/performance/node/analysis/netinterface/components/LineStatusTable';
import WSyslogTable from '@/views/performance/node/analysis/netinterface/components/SyslogTable';
import WConnectionDeviceTable from '@/views/performance/node/analysis/netinterface/components/ConnectionDeviceTable';
import netineterfaceTableInfoAPI from '@/api/performance/netinterface/netinterface-table-info';
import AnalysisTable from '@/mixins/performance/analysis-table';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';

export default {
  name: 'WPerformanceNetinterfaceAnalysisTable',
  components: {
    WLineStatusTable,
    WSyslogTable,
    WConnectionDeviceTable,
  },
  mixins: [AnalysisTable],
  props: {
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      analysisTimeType,
      activeTab: 'lineStatus',
      lineStatusData: {},
      syslogTableData: [],
      connectionDeviceTableData: {},
      timeType: {
        lineStatus: defaultAnalysisTimeType,
        connectionDevice: defaultAnalysisTimeType,
      },
      isChangeNodeFlag: true, // true일 경우 (현재/이력) 모든 부분을 이력으로 변경한다.
    };
  },
  computed: mapGetters(['selectedNode', 'plotLineDatetime']),
  watch: {
    /**
     * [plotLineDatetime 차트 클릭시 테이블 데이터 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    plotLineDatetime() {
      this.selectedTabTableLoad();
    },
    /**
     * [activeTab 탭 선택시 로드]
     * @author {Yang}
     * @return {[String]}
     */
    activeTab() {
      this.selectedTabTableLoad();
    },
    /**
     * [분석] 탭이 활성화 시 현재 보여지는 탭의 데이터를 재로드한다.
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.selectedTabTableLoad();
      }
    },
    selectedNode: {
      handler() {
        if (!this.active) {
          return;
        }
        this.isChangeNodeFlag = true;

        // [운영 탭] 차트 로드시 연쇄적인 로드 불가능, 운영 탭 상태에서 노드를 변경할 때 화면 재로드 호출
        if (this.operationFlag) {
          this.selectedTabTableLoad();
        }
      },
      immediate: true,
    },
  },
  methods: {
    selectedTabTableLoad() {
      if ((isNil(this.plotLineDatetime) && !this.operationFlag) || !this.active || isEmpty(this.selectedNode)) {
        return;
      }
      if (this.isChangeNodeFlag) {
        this.clearTimeType();
        this.$nextTick(() => {
          this.loadTableData();
          this.isChangeNodeFlag = false;
        });
      } else {
        this.loadTableData();
      }
    },
    /**
     * [ 인터페이스 상태 리스트 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    lineStatusLoadStore() {
      if (this.timeType.lineStatus === this.analysisTimeType.HIST.value && !this.operationFlag) {
        const params = {
          parentObjId: this.selectedNode.obj.parentObjId,
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          managetypeId: 'NMS',
        };
        netineterfaceTableInfoAPI.getLineStatusList(params).then((result) => {
          if (result.data.success === true) {
            this.lineStatusData = result.data.data;
            this.lineStatusData.timeType = this.timeType.lineStatus;
          }
        });
      } else {
        const params = {
          objId: this.selectedNode.obj.objId,
          managetypeId: 'NMS',
        };
        netineterfaceTableInfoAPI.getCurrentInterfaceStatus(params).then((result) => {
          if (result.data.success === true) {
            // const currentListData = Object.assign({}, result.data.data);
            // this.$set(this.lineStatusData, 'currentList', currentListData);
            this.lineStatusData = {};
            this.lineStatusData.currentList = result.data.data;
            this.lineStatusData.timeType = this.operationFlag ? this.analysisTimeType.CURRENT : this.timeType.lineStatus;
          }
        });
      }
    },
    /**
     * [ Syslog 리스트 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    sysloagLoadStore() {
      const params = {
        parentObjId: this.selectedNode.obj.parentObjId,
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.plotLineDatetime,
        managetypeId: 'NMS',
      };
      netineterfaceTableInfoAPI.getSysLogList(params).then((result) => {
        if (result.data.success === true) {
          this.syslogTableData = result.data.data;
        }
      });
    },
    /**
     * [ 연결장비 리스트 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    connectionDeviceLoadStore() {
      if (this.timeType.connectionDevice === this.analysisTimeType.HIST.value) {
        const params = {
          parentObjId: this.selectedNode.obj.parentObjId,
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          managetypeId: 'NMS',
        };
        netineterfaceTableInfoAPI.getConnectionDeviceList(params).then((result) => {
          if (result.data.success === true) {
            this.connectionDeviceTableData = result.data.data;
            this.connectionDeviceTableData.timeType = this.timeType.connectionDevice;
          }
        });
      } else {
        const params = {
          objId: this.selectedNode.obj.objId,
        };
        netineterfaceTableInfoAPI.getCurrentConnectionDeviceList(params).then((result) => {
          if (result.data.success === true) {
            this.$set(this.connectionDeviceTableData, 'currentList', result.data.data);
            this.connectionDeviceTableData.timeType = this.timeType.connectionDevice;
          }
        });
      }
    },
    /**
     * [selectionTabTableLoad 선택된 탭의 테이블 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadTableData() {
      switch (this.activeTab) {
        case 'lineStatus':
          this.lineStatusLoadStore();
          break;
        case 'syslog':
          this.sysloagLoadStore();
          break;
        case 'connectionDevice':
          this.connectionDeviceLoadStore();
          break;
        default:
          this.lineStatusLoadStore();
      }
    },
    setTimeType(type, value) {
      this.timeType[type] = value;
      this.selectedTabTableLoad();
    },
    clearTimeType() {
      const hist = defaultAnalysisTimeType;
      this.$set(this.timeType, 'lineStatus', hist);
      this.$set(this.timeType, 'connectionDevice', hist);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netinterface/PerformanceNetinterfaceAnalysisTable.vue